<template>
  <div class="sub-page">
    <!-- 顶部导航栏与紫色渐变背景 -->
    <div class="sub-header">
      <van-nav-bar title="資金管理" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#ffffff" size="24" @click="back()" />
        </template>
      </van-nav-bar>
    </div>

    <!-- 内容卡片区域 -->
    <div class="sub-body">
      <!-- 卡片 1: 金融卡 -->
      <div class="card-box">
        <div class="card-head">
          <span class="card-title">金融卡</span>
          <span class="status-tag" :class="{ bound: is_bind }">
            {{ is_bind ? '已設置' : '未設置' }}
          </span>
        </div>
        <div class="card-content" @click="toBindCard()">
          <template v-if="!is_bind">
            <span class="action-btn">
              <i class="plus-icon">+</i> 添加銀行卡
            </span>
          </template>
          <template v-else>
            <div class="bound-info">
              <p class="bank-name">{{ bankInfo.bankinfo }}</p>
              <p class="card-num">{{ bankInfo.bankid }}</p>
              <p class="user-name">{{ bankInfo.username || userInfo.name }}</p>
            </div>
          </template>
        </div>
      </div>

      <!-- 卡片 2: TRC20 -->
      <div class="card-box">
        <div class="card-head">
          <span class="card-title">TRC20</span>
          <span class="status-tag" :class="{ bound: is_usdt_trc }">
            {{ is_usdt_trc ? '已設置' : '未設置' }}
          </span>
        </div>
        <div class="card-content" @click="toBindUsdt('TRC20')">
          <template v-if="!is_usdt_trc">
            <span class="action-btn">
              <i class="plus-icon">+</i> 綁定 USDT
            </span>
          </template>
          <template v-else>
            <div class="bound-info">
              <p class="bank-name">TRC20</p>
              <p class="card-num">{{ usdtInfo.trc_address }}</p>
            </div>
          </template>
        </div>
      </div>

      <!-- 卡片 3: ERC20 -->
      <div class="card-box">
        <div class="card-head">
          <span class="card-title">ERC20</span>
          <span class="status-tag" :class="{ bound: is_usdt_erc }">
            {{ is_usdt_erc ? '已設置' : '未設置' }}
          </span>
        </div>
        <div class="card-content" @click="toBindUsdt('ERC20')">
          <template v-if="!is_usdt_erc">
            <span class="action-btn">
              <i class="plus-icon">+</i> 綁定 USDT
            </span>
          </template>
          <template v-else>
            <div class="bound-info">
              <p class="bank-name">ERC20</p>
              <p class="card-num">{{ usdtInfo.erc_address }}</p>
            </div>
          </template>
        </div>
      </div>

      <!-- 底部提示文字 -->
      <div class="tip-text">
        提示:請綁定大型商業銀行,如需修改,請您聯繫在線客服
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind: false,
      is_usdt_trc: false,
      is_usdt_erc: false,
      bankInfo: {},
      userInfo: {},
      usdtInfo: {}
    };
  },
  methods: {
    back() {
      this.$router.push({ path: '/Mine' });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          const info = res.data.info || res.data.bank_info || {};
          this.bankInfo = info;

          // 只有存在银行卡号(bankid)和银行信息(bankinfo)时才判断为已绑定金融卡
          const hasCard = !!((info.bankid || info.bankcard) && (info.bankinfo || info.bank_name));
          this.is_bind = hasCard;

          const trc_addr = info.usdt || info.trc_usdt || '';
          const erc_addr = info.erc_usdt || '';

          this.is_usdt_trc = !!trc_addr;
          this.is_usdt_erc = !!erc_addr;
          this.usdtInfo = {
            trc_address: trc_addr,
            erc_address: erc_addr
          };
        } else if (res && res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.userInfo = res.data;
        } else if (res && res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toBindCard() {
      this.$router.push({ path: '/BindCard' });
    },
    toBindUsdt(type) {
      this.$router.push({ path: '/BindUsdt', query: { type } });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  box-sizing: border-box;
}

/* 顶部导航栏与紫粉渐变背景 */
.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px !important;
}

::v-deep .sub-nav .van-icon-arrow-left {
  color: #ffffff !important;
  font-size: 40px !important;
}

/* 内容主体 */
.sub-body {
  position: relative;
  margin-top: -60px;
  padding: 0 24px 40px;
  box-sizing: border-box;
}

/* 卡片样式 */
.card-box {
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  padding: 28px 32px 36px;
  margin-bottom: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;
}

.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.card-title {
  font-size: 30px;
  font-weight: 700;
  color: #1a1a1a;
}

.status-tag {
  font-size: 22px;
  color: #ff4d6d;
  background: #ffe6eb;
  padding: 4px 18px;
  border-radius: 30px;
  font-weight: 500;
}

.status-tag.bound {
  color: #07c160;
  background: #e8f8f0;
}

.card-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0 10px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.action-btn {
  color: #8e44ad;
  font-size: 30px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.plus-icon {
  font-style: normal;
  font-size: 34px;
  margin-right: 10px;
  font-weight: 400;
}

.bound-info {
  width: 100%;
  text-align: left;
}

.bound-info p {
  margin: 6px 0;
  font-size: 26px;
  color: #333333;
}

.bound-info .bank-name {
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
}

.bound-info .card-num {
  font-size: 26px;
  color: #666666;
}

/* 提示文字 */
.tip-text {
  font-size: 22px;
  color: #888888;
  padding: 8px 10px;
  line-height: 1.5;
  text-align: left;
}
</style>
